export const ErrorPage = () => {

    return (
        <div>
            <h2 className="error-heading">404 - Invalid URL</h2>
        </div>
    )
}